// extracted by mini-css-extract-plugin
module.exports = {"light":"ContentLayout_light__1X5Q5","dark":"ContentLayout_dark__25HbA","pageTitle":"ContentLayout_pageTitle__2lDuc","mainContentWrapper":"ContentLayout_mainContentWrapper__k1fv_"};